import _ from "lodash";

const GROUP_CATEGORY = {
  GENERAL: "General",
  FEATURES: "Features",
  STATS: "Stats",
  SIGNATURE: "Signature",
};

const baseGroupings = [
  {
    groupName: GROUP_CATEGORY.GENERAL,
    keys: [
      "disableCustomDimension",
      "advertiserId",
      "billableAdvertiserId",
      "userId",
      "timezone",
      "currency",
      "rootUnitId",
      "customFields",
      "customTargetingKeys",
      "customTargetingValues",
      "priceModifier",
      "dummyAdUnitId",
      "roleId",
      "firstlookCurrency",
      "billableHouseAdvertiserIds",
    ],
  },
  {
    groupName: GROUP_CATEGORY.FEATURES,
    keys: [
      "usePlacementForShareResources",
      "scriptImplementationVersion",
      "preservedLineItemIds",
      "preservedCreativeIds",
      "dispatcherTagging",
      "clientSideTagging",
    ],
  },
  {
    groupName: GROUP_CATEGORY.STATS,
    keys: [
      "stats.customTargetingKeys",
      "stats.customTargetingValues.customDimension",
      "stats.customTargetingValues.notReportable",
      "stats.customTargetingValues.reportable",
      "stats.uprs",
      "stats.scheduleReports",
    ],
  },
  {
    groupName: GROUP_CATEGORY.SIGNATURE,
    keys: ["report", "upr"],
  },
];

export function getNetworkResourceSchema(defaultConfig = {}) {
  const schemas = _getSchemas();
  _.forEach(schemas, (s) => {
    if (s.prefix === "") {
      s.defaultValue = _.get(defaultConfig, [s.key], "-");
    } else {
      s.defaultValue = _.get(defaultConfig, [s.prefix, s.key], "-");
    }
  });
  return _.reduce(
    baseGroupings,
    (result, group) => {
      let { groupName, keys } = group;
      _.forEach(schemas, (keyConfig) => {
        if (_.indexOf(keys, keyConfig.key) !== -1) {
          keyConfig.groupCategory = groupName;
          result.push(keyConfig);
        }
      });
      return result;
    },
    []
  );
}

export function getDataScehmaDiff({ data, schema }) {
  let diff = _.cloneDeep(data);
  _.forEach(schema, (s) => {
    const keyPath = s.prefix
      ? [s.prefix, ...s.key.split(".")]
      : s.key.split(".");

    if (_.has(diff, keyPath)) {
      // delete the key if match
      diff = _.omit(diff, keyPath);
    }
  });
  return _.keys(diff).map((key) => ({
    key,
    description: "",
    valueType: "string",
    prefix: "",
    groupCategory: "Undefined",
  }));
}

function _getSchemas() {
  return [
    {
      key: "usePlacementForShareResources",
      description: "",
      valueType: "boolean",
      prefix: "features",
    },
    {
      key: "scriptImplementationVersion",
      description: "",
      valueType: "string",
      prefix: "features",
    },
    {
      key: "preservedLineItemIds",
      description: "",
      valueType: "array_integer",
      prefix: "features",
    },
    {
      key: "preservedCreativeIds",
      description: "",
      valueType: "array_integer",
      prefix: "features",
    },
    {
      key: "dispatcherTagging",
      description: "",
      valueType: "general_object",
      prefix: "features",
    },
    {
      key: "clientSideTagging",
      description: "",
      valueType: "general_object",
      prefix: "features",
    },
    {
      key: "disableCustomDimension",
      description: "",
      valueType: "boolean",
      prefix: "",
    },
    {
      key: "advertiserId",
      description: "",
      valueType: "number",
      prefix: "",
    },
    {
      key: "billableAdvertiserId",
      description: "",
      valueType: "number",
      prefix: "",
    },
    {
      key: "userId",
      description: "",
      valueType: "number",
      prefix: "",
    },
    {
      key: "timezone",
      description: "",
      valueType: "string",
      prefix: "",
    },
    {
      key: "currency",
      description: "",
      valueType: "string",
      prefix: "",
    },
    {
      key: "rootUnitId",
      description: "",
      valueType: "number",
      prefix: "",
    },
    {
      key: "customFields",
      description: "",
      valueType: "targeting_key",
      prefix: "",
    },
    {
      key: "customTargetingKeys",
      description: "",
      valueType: "targeting_key",
      prefix: "",
    },
    {
      key: "customTargetingValues",
      description: "",
      valueType: "targeting_value",
      prefix: "",
    },
    {
      key: "priceModifier",
      description: "",
      valueType: "number",
      prefix: "",
    },
    {
      key: "dummyAdUnitId",
      description: "",
      valueType: "number",
      prefix: "",
    },
    {
      key: "roleId",
      description: "",
      valueType: "number",
      prefix: "",
    },
    {
      key: "firstlookCurrency",
      description: "",
      valueType: "string",
      prefix: "",
    },
    {
      key: "billableHouseAdvertiserIds",
      description: "",
      valueType: "array_integer",
      prefix: "",
    },
    {
      key: "report",
      description: "",
      valueType: "string",
      prefix: "signature",
    },
    {
      key: "upr",
      description: "",
      valueType: "string",
      prefix: "signature",
    },
    {
      key: "stats.customTargetingKeys",
      description: "",
      valueType: "number",
      prefix: "",
      title: "Custom Targeting Keys",
    },
    {
      key: "stats.customTargetingValues.customDimension",
      description: "",
      valueType: "targeting_key",
      prefix: "",
      title: "Custom Targeting Values - Custom Dimension",
    },
    {
      key: "stats.customTargetingValues.notReportable",
      description: "",
      valueType: "targeting_key",
      prefix: "",
      title: "Custom Targeting Values - Not Reportable",
    },
    {
      key: "stats.customTargetingValues.reportable",
      description: "",
      valueType: "targeting_key",
      prefix: "",
      title: "Custom Targeting Values - Reportable",
    },
    {
      key: "stats.uprs",
      description: "",
      valueType: "number",
      prefix: "",
      title: "UPRs",
    },
    {
      key: "stats.scheduleReports",
      description: "",
      valueType: "number",
      prefix: "",
      title: "Scheduled Reports",
    },
  ];
}
